import { render } from "./Other.vue?vue&type=template&id=cef7f9ae"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"

import "./Other.vue?vue&type=style&index=0&id=cef7f9ae&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__